// Copyright (c) 2020 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { FormattedMessage, defineMessages } from "react-intl";

import { IAction } from "actions";
import { isSet } from "shared/utils/utils";
import { DashboardPanel } from "types";
import { getSiteSelection } from "guiutils";
import { IState } from "states/states";
import { GraphViewMode } from "states/cachedstates";
import EnergyGraph from "view/comp/EnergyGraph";
import TrendHeading from "view/comp/TrendHeading";
import TrendDatatable from "view/comp/TrendDatatable";
import Power from "./Power";
import { ISiteBarSearchFieldProps } from "view/comp/SiteBar";
import TrendSiteBar from "view/comp/TrendSiteBar";
import ModalTariffsFilter from "view/modal/ModalTariffsFilter";

interface ITrendProps {
  graphViewMode: GraphViewMode;
  selectedTimestamp: number | undefined;
}

interface ITrendState {}

const mapStateToProps = (state: IState) => {
  const selection = getSiteSelection(state);

  const props: ITrendProps = {
    graphViewMode: selection?.graphViewMode ?? GraphViewMode.BAR,
    selectedTimestamp: state.gui.selectedTimestamp,
  };
  return props;
};

interface ITrendDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: ITrendDispatch = {};
  return dispatchProps;
};

const messages = defineMessages({
  placeholderSearchField: {
    id: "Highlight tariffs circuits...",
  },
});

class TrendComponent extends React.Component<ITrendProps & ITrendDispatch, ITrendState> {
  public render() {
    // render details of selected timestamp or the timeseries?
    const searchFieldProps: ISiteBarSearchFieldProps = {
      placeholder: messages.placeholderSearchField,
    };

    return (
      <>
        <TrendSiteBar
          showBackButton={isSet(this.props.selectedTimestamp)}
          showPeriodSelect={!isSet(this.props.selectedTimestamp)}
          searchFieldProps={isSet(this.props.selectedTimestamp) ? searchFieldProps : undefined}
        />
        {isSet(this.props.selectedTimestamp) ? this.renderTimestamp() : this.renderTimeseries()}
        <ModalTariffsFilter />
      </>
    );
  }

  private renderTimeseries() {
    return (
      <>
        <div id="trend" className="flex-self flex-content">
          <TrendHeading
            identifier="trendPeriod"
            includeDate={true}
            showTrendData={true}
            showGraphModes={[GraphViewMode.BAR, GraphViewMode.LINE, GraphViewMode.TABLE]}
            title={
              this.props.graphViewMode === GraphViewMode.TABLE ?
                <FormattedMessage id="Trend Data" />
              : undefined
            }
          />
          {this.props.graphViewMode !== GraphViewMode.TABLE ?
            <EnergyGraph showLegend={true} panel={DashboardPanel.ENERGY} />
          : <TrendDatatable panel={DashboardPanel.ENERGY} />}
        </div>
      </>
    );
  }

  private renderTimestamp() {
    return (
      <div id="trend-timestamp">
        <Power panel={DashboardPanel.ENERGY} />
      </div>
    );
  }
}

const Trend = connect(mapStateToProps, mapDispatchToProps)(TrendComponent);

export default Trend;
